/**
 * Банк слов задания с пропусками (`gap_fill` в режиме перетаскивания).
 *
 * ⚠️ ОДНА ПЛАШКА НА КАЖДЫЙ ПРОПУСК, ДАЖЕ ЕСЛИ СЛОВА СОВПАДАЮТ. До 13.10.2026 банк
 * собирался через `new Set`, и в «[[get]] up … [[get]] down» ученик видел одну
 * плашку «get»: второй пропуск заполнить было нечем, «Проверить» не нажималась,
 * раздел не закрывался. На проде так застряло задание «had … had» (копия 13.10).
 *
 * Отвлекающие слова — без повторов и без совпадений с уже лежащими в банке: в
 * Edvibe-записи «[is / are со звёздочкой] … [is со звёздочкой / are]» верное слово
 * одного пропуска — ловушка другого, и банк должен остаться из двух плашек, как был.
 * (Звёздочку со слэшем здесь не писать: «звёздочка-слэш» закрывает комментарий.)
 */
export function gapBank(
  gaps: { answers: string[]; distractors?: string[] }[],
  shared: string[] = [],
): string[] {
  const bank = gaps.map((g) => g.answers[0]).filter((w): w is string => !!w);
  const seen = new Set(bank);
  for (const w of [...gaps.flatMap((g) => g.distractors ?? []), ...shared]) {
    if (!w || seen.has(w)) continue;
    seen.add(w);
    bank.push(w);
  }
  return bank;
}

/** Варианты выпадающего списка: повтор слова в `<select>` ничего не даёт ученику. */
export const uniqueWords = (words: string[]): string[] => Array.from(new Set(words));
